var swiper_nav_slider = null
const mainNavCollapsible = document.getElementById('nav_bar_v3')

if (mainNavCollapsible !== null) {
  runNavSlider()
}

function runNavSlider () {

  const paginationEl = document.querySelector('.js_nav_slider .swiper-pagination')
  let isInnerFixed = false
  var swiper_nav_slider_options = {
    // slidesPerView: 'auto',
    loop: true,
    centeredSlides: true,
    slidesPerView: 2,
    preventClicks: true,
    speed: 500,
    a11y: false,
    // init: false,
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2.2,
      },
      1200: {
        spaceBetween: 0,
        slidesPerView: 3,
      }
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    navigation: {
      nextEl: '.js_nav_slider_nav .swiper-button-next',
      prevEl: '.js_nav_slider_nav .swiper-button-prev',
    },
    on: {

      slideChangeTransitionEnd: function () {
        // Remove click events from all slides
        jQuery('.js_nav_slider .nav-slider__card-link').off('click')
        setTimeout(function () {
          // Add click event only for current prev and next slide
          jQuery('.js_nav_slider .swiper-slide-next .nav-slider__card-link').on('click', function (e) {
            e.preventDefault()
            swiper_nav_slider.slideNext()
          })
          jQuery('.js_nav_slider .swiper-slide-prev .nav-slider__card-link').on('click', function (e) {
            e.preventDefault()
            swiper_nav_slider.slidePrev()
          })
        }, 100)
      }
    },
  }

// Toggle HTML scroll lock on menu open/close

  mainNavCollapsible.addEventListener('show.bs.collapse', event => {
    document.getElementsByTagName('html')[0].classList.add('lock-scroll')

    // Init slider on menu open
    if (swiper_nav_slider == null) {
      swiper_nav_slider = new Swiper('.js_nav_slider', swiper_nav_slider_options)
    }

    // After slider init update DOM - fix for firefox writing-mode problem
    fixCardHeaderInnerEl()
  })
  mainNavCollapsible.addEventListener('hidden.bs.collapse', event => {
    document.getElementsByTagName('html')[0].classList.remove('lock-scroll')
    if (swiper_nav_slider != null) {
      swiper_nav_slider.destroy()
      swiper_nav_slider = null
    }

  })

  function fixCardHeaderInnerEl () {
    setTimeout(function () {
      if (!isInnerFixed) {
        jQuery('.nav-slider__card-header-inner').css({ 'height': '100.5%' })
        isInnerFixed = true
      }
      else {
        jQuery('.nav-slider__card-header-inner').css({ 'height': '100%' })
        isInnerFixed = false
      }
    }, 100)
  }

  const handleNavbarTransition = () => {
    const navbarToggler = document.querySelector('.navbar-toggler.collapsed')
    if (navbarToggler) {

      navbarToggler.addEventListener('click', event => {
        event.preventDefault()
        event.stopPropagation()

        const mainNavCollapsible = document.querySelector('.navbar-collapse')

        if (!mainNavCollapsible.classList.contains('show')) {
          mainNavCollapsible.style.height = '0'
        }

      })
    }
  }

  handleNavbarTransition()

}
